import { productReferences } from "@/cms/lib/productCards";

import type { BlockBase } from "@/cms/blocks/registry/types";

export type HeadingBlock = BlockBase<
  "heading",
  { level: 1 | 2 | 3 | 4 | 5 | 6; text: string }
>;

export type ParagraphBlock = BlockBase<
  "paragraph",
  {
    richText?: any;
    text?: string;
    variant?: "default" | "shortDescription";
  }
>;

export type ImageBlockData = {
  assetId?: string;
  url?: string;
  alt?: string;
  width?: number;
  height?: number;
  variant?: "default" | "hero";
};

export type ImageBlockType = BlockBase<"image", ImageBlockData>;

export type ProductListItem = {
  productId?: string;
  partNumber?: string | null;
};

export type ProductCardBlock = BlockBase<
  "productCard",
  {
    products?: ProductListItem[];
    productId?: string;
    partNumber?: string | null;
  }
>;

export function findBlock<TType extends string, TData = any>(
  blocks: BlockBase[],
  type: TType
): BlockBase<TType, TData> | undefined {
  return blocks.find(
    (block): block is BlockBase<TType, TData> => block.type === type
  );
}

export function findBlocks<TType extends string, TData = any>(
  blocks: BlockBase[],
  type: TType
): BlockBase<TType, TData>[] {
  return blocks.filter(
    (block): block is BlockBase<TType, TData> => block.type === type
  );
}

export function findParagraphByVariant(
  blocks: BlockBase[],
  variant: ParagraphBlock["data"]["variant"]
): ParagraphBlock | undefined {
  return blocks.find(
    (block): block is ParagraphBlock =>
      block.type === "paragraph" && (block.data as ParagraphBlock["data"]).variant === variant
  );
}

export function findImageByVariant(
  blocks: BlockBase[],
  variant: ImageBlockData["variant"]
): ImageBlockType | undefined {
  return blocks.find(
    (block): block is ImageBlockType =>
      block.type === "image" && (block.data as ImageBlockData)?.variant === variant
  );
}

export function normalizeProductList(
  productCard?: ProductCardBlock
): ProductListItem[] {
  return productReferences(productCard?.data);
}
